export const formatProfileCode = (data = ''): string => {
  const onlyNumbers = data.replaceAll('-', '').replaceAll(' ', '');
  return onlyNumbers.replace(/(.{3,4})/g, ' - $1').substr(2, 40);
};
